import recordStore from "@/store/record.store";
import { moveCursorToElementStart, placeCaretAtEnd } from "@/utils/range";
import { useEffect } from "react";
import ListItem from "../ListItem";
import LazyItem from "@/component/LazyList/LazyItem";

function RecordList() {
  const list = recordStore((state) => state.records);
  const operatedInfo = recordStore((state) => state.operatedInfo);

  const handleFocusOperate = (wi: string) => {
    const span = document.querySelector(`[data-word-id="${wi}"]`);
    if (span) {
      moveCursorToElementStart(span);
    }
  };

  const handleFocusPara = (pi: string) => {
    const p = document.querySelector(`[data-p-id="${pi}"]`);
    if (p) {
      placeCaretAtEnd(p);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (operatedInfo.wi) {
        handleFocusOperate(operatedInfo.wi);
      } else if (operatedInfo.pi) {
        handleFocusPara(operatedInfo.pi);
      }
    }, 0);
  }, [operatedInfo]);

  return list.map((record, index) => (
    <LazyItem item={record} index={index}>
      <ListItem key={record.pi} record={record} />{" "}
    </LazyItem>
  ));
}
export default RecordList;
